$(document).ready(function() {  
   var heights = $(".testinomial_jtpl .review--has-image").map(function ()
    {
        return $(this).height();
    }).get();
    maxHeight = Math.max.apply(null, heights);
    $(".testinomial_jtpl .review--has-image").height(maxHeight);
  
  // $(window).on('resize', function(){

  // });
  
  $(document).on('click','.product__badge .product__badge-link',function(e){
     e.preventDefault();
      //e.stopPropagation();
   if($(this).attr("data-scroll-to")){
      var target = "#judgeme_product_reviews.jdgm-widget";
      console.log(target);
      $('html, body').animate({scrollTop: $(target).offset().top -130 },100);
    }
    return false;
  }); 


  $('body').on('click', '.checkboxofaddons', function(){
    var myCart = $(this).is(":checked");
    
    
    if(myCart == true){
      $('.aadd-on').addClass('add-id');
      $('.aadd-on').attr('name', 'id');
      $('.product-heading').removeClass('cst-my');
    }
    else{
      $('.addons-price').html('');
      $('.aadd-on').removeClass('add-id');
      $('.aadd-on').attr('name','prd'); 
      $('.product-heading').addClass('cst-my');
      $('.varient-product').prop('checked', false);
    }
  })


  
// if ($(window).width() > 768) {
//       $('.rating').bind("click", function () {
// 	     $('html, body').animate({ scrollTop:7670 },"fast");
// 	     return false;
// 	});
//         }


  

$(document).on("click", '.varient-cstm', function(){ 
  var id = $(this).attr('data-id');
  var addonsPrice = $(this).attr('data-price');
  $('.addons-price').html(' ('+addonsPrice+')');
  $('.aadd-on').val(id);
  // alert(id);
});


  
var counts = 1;
$(document).on("click", '.jtpl-custom-add-tocart', function(event){

  event.stopPropagation(); // Prevent event from propagating up the DOM tree
  event.preventDefault();

 
  var addOnsId = $('input.aadd-on.add-id').val();
 
  if(typeof addOnsId != 'undefined' && addOnsId != 0){
    addOnCart();
    setTimeout(function(){
      mainCart()
    }, 500)
    
  }
  else{
     mainCart()
  }
  setTimeout(function(){
     opeCart();
    }, 1100);
 
  
});


function mainCart(){
  var quantity = $('.qty-select[name="quantity"]').val();
     var id = $('input.main-product').val();
  if(typeof id != 'undefined'){
  if(id.length > 0){

    $('.product__form__errors').html('');
   $.ajax({
     'url' : '/cart/add.js',
     'type' : 'POST',
     'dataType' : 'JSON',
     'data' : { id: id , quantity : quantity },
       success : function(cartdata){
         console.log(cartdata);
      },
      error: function(response) {
        var error = '<div class="errors">Cart Error: '+response.responseJSON.description+'.<span class="errors__close" data-close-error=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg></span></div>';
        $('.product__form__errors').addClass('is-visible');
        $('.product__form__errors').html(error);
      }
    });
 
  }
  }
}

function addOnCart(){
  var quantity = $('.qty-select[name="quantity"]').val();
     var id = $('input.aadd-on.add-id').val();
  if(typeof id != 'undefined'){
  if(id.length > 0){
 
    $('.product__form__errors').html('');
   $.ajax({
     'url' : '/cart/add.js',
     'type' : 'POST',
     'dataType' : 'JSON',
     'data' : { id: id , quantity : quantity },
       success : function(cartdata){
         console.log(cartdata);
         //alert("success");
      },
      error: function(response) {
       
        console.log('Error Cart',response.responseJSON.description);
        var error = '<div class="errors">Cart Error: '+response.responseJSON.description+'.<span class="errors__close" data-close-error=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg></span></div>';
        $('.product__form__errors').addClass('is-visible');
        $('.product__form__errors').html(error);
      }
    });

  }
  }
}

  function opeCart(){
     window.cart.getCart(); 
         document.querySelector('.iCartBtnToggle').click();
  }
// $(document).on("click", '.customAddToCart', function(event){
//   event.preventDefault();
//   var items = [];
//   $('.add-id').each(function (){

//       items.push({
//         id: $(this).val(),
//         quantity: $('.qty-select[name="quantity"]').val();
//       });
//     });

//   setTimeout(function(){
//    $.ajax({
//      'url' : '/cart/add.js',
//      'type' : 'POST',
//      'dataType' : 'JSON',
//       data: {
//         items: items,
//       },
//        success : function(cartdata){
//          console.log(cartdata);
//         // alert("success");
//       }
//     });
//   }, 500)
// });




//image -with slider
// function mobileOnlySlider() {
// $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   asNavFor: '.slider-nav'
// });
// $('.slider-nav').slick({
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   asNavFor: '.slider-for',
//   centerMode: true,
//   focusOnSelect: true
// });
// }
// if(window.innerWidth < 768) {
// mobileOnlySlider();
// }

// $(window).resize(function(e){
//     if(window.innerWidth < 768) {
//         if(!$('.slider-for').hasClass('slick-initialized')){
//          mobileOnlySlider();
//         }
//     }
// });

  
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  centerMode: true,
  infinite: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    }
  ]
});






      


if ($(window).width() > 768) {
  
  var img_height = $(".video_jtpl_section .block-with-small-img").height();
  $(".video_jtpl_section .column__image__wrapper .column__image").css("height",img_height+'px');
  $(".video_jtpl_section .column__image__wrapper .column__image").css("padding-top", '0px');
}

  
 $('#accordion').find('.accordion-toggle').click(function(){
      var isActive = $(this).hasClass("active");
			$('.accordion-toggle').removeClass('active')
      if (!isActive) {
        $(this).toggleClass('active');
      }
      $(this).next().slideToggle('fast');     
      $(".accordion-content").not($(this).next()).slideUp('fast');
    });
  
  // if( $(".product__description__content__inner .accordion:first-child .heading").length > 0){
  //   $(".product__description__content__inner .accordion:first-child .heading").trigger("click");    
  // }
 
$(".accordion").on("click", ".heading", function() {
       $(this).toggleClass("active").next().slideToggle();
       $(".contents").not($(this).next()).slideUp(300);
       $(this).siblings().removeClass("active");
       });
  
});

$('body').on('click', '.radio__button label', function(){
  setTimeout(function(){
  $('.hide-varinat-desc').hide();
  var path_name = window.location.href;
  var variant_id = path_name.split('?variant=');  
  
  $('.variant_desc_'+variant_id[1]).css('display', 'block');
    }, 200)
});

$(document).ready(function(){
  var path_name = window.location.href;
  var variant_id = path_name.split('?variant=');
  $('.variant_desc_'+variant_id[1]).css('display', 'block');
})
